export enum CreditStatus {
  CREDIT_PASSED,
  CREDIT_FAILED,
  CREDIT_TIMEDOUT,
}

export namespace CreditStatus {
  let elements = [
    CreditStatus.CREDIT_PASSED,
    CreditStatus.CREDIT_FAILED,
    CreditStatus.CREDIT_TIMEDOUT,
  ];
  let alias = "com.bcdfx.model.CreditStatus";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
